import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

const DUTCH_FOOTER = 'footer';
const ENGLISH_FOOTER = 'en-footer';

const FooterMenu = () => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  let menuId = DUTCH_FOOTER;
  // Load a specific menu on english language for the Main corporate site
  if (currentLanguage !== DEFAULT_LANGUAGE) menuId = ENGLISH_FOOTER;

  return (
    <Menu id={menuId} className="FooterMenu">
      {(items) => {
        return (
          <div className="row">
            {items.map((item) => {
              // The first layer is purely for layout.
              return (
                <div key={item.getIn(['link', 'title'], 'Untitled')} className="FooterMenu__level col-12 col-md-6 col-lg-3">
                  {
                    item.get('subtree').map((section) => {
                      // The second layer is a title. In most cases the title links to a page, in some cases it does not.
                      return (
                        <div key={section.getIn(['link', 'title'], 'Untitled')} className="FooterMenu__section">
                          <h4>
                            {section.getIn(['link', 'route_name']) === '<nolink>' ? (
                              <span>{section.getIn(['link', 'title'], 'Untitled')}</span>
                            ) : (
                              <CoreLink href={section.getIn(['link', 'url'], '/')}>
                                {section.getIn(['link', 'title'], 'Untitled')}
                                <i className="icon icon-before icon-arrow-right icon-variant-2" />
                              </CoreLink>
                            )}
                          </h4>
                          <div>
                            {
                              section.get('subtree').map((link) => {
                                // The third layer contains actual links.
                                const title = link.getIn(['link', 'title'], 'Untitled');
                                const url = link.getIn(['link', 'url'], '');
                                const active = link.getIn(['link', 'url']) === currentPage;
                                const FooterMenuItemClassnames = c('FooterMenu__item', {
                                  'FooterMenu__item--active': active,
                                });
                                return (
                                  <div key={title} className={FooterMenuItemClassnames}>
                                    <CoreLink
                                      className="FooterMenu__item__link"
                                      href={url}
                                    >
                                      <span className="FooterMenu__item__title">{title}</span>
                                    </CoreLink>
                                  </div>
                                );
                              })
                            }
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              );
            })}
          </div>
        );
      }}
    </Menu>
  );
};

export default FooterMenu;
